export default __webpack_public_path__ + "static/pic4-7a30f2ef9022c89aa41f888a909bfbb7.jpeg";